/**
 * Location context store — BOLT-166.
 *
 * Persists the selected location ID to localStorage so the portal-wide
 * location filter survives page refreshes and browser restarts.
 *
 * null = "All locations" (no filter applied).
 *
 * Components read: useLocationStore((s) => s.selectedLocationId)
 * Components write: useLocationStore((s) => s.setSelectedLocationId)(id)
 */
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface LocationState {
  /** Currently selected location ID, or null for "All locations". */
  selectedLocationId: string | null;
  /** Update the selected location. Pass null for "All locations". */
  setSelectedLocationId: (id: string | null) => void;
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      selectedLocationId: null,
      setSelectedLocationId: (id) => set({ selectedLocationId: id }),
    }),
    {
      name: 'selectedLocationId',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
